module.exports = __webpack_public_path__ + "img/bg0.85308647.png";